import { ReactNode } from 'react';

import Fade from '@mui/material/Fade';

import { Box } from '@vk-hr-tek/ui/Box';

interface PageFullHeightProps {
  title: ReactNode;
  children: ReactNode;
}

export const PageFullHeight = ({ title, children }: PageFullHeightProps) => (
  <Box
    display="flex"
    flexDirection="column"
    height="100%"
    flexGrow={1}
    minHeight={0}
  >
    {title}
    <Fade timeout={1000} in>
      <Box display="flex" flexDirection="column" flexGrow={1} minHeight={0}>
        {children}
      </Box>
    </Fade>
  </Box>
);
